













































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import { Quill } from "vue-quill-editor";
import { ImageDrop } from "quill-image-drop-module";
import AnnoucementService from "@/services/Annoument.service";
import GenericAdd from "../../core/Generics/GenericAdd";
import Porposal from "@/models/porposal/porposal.model";
import { PorposalModality } from "@/enums/PorposalModality";
import CoinService from "@/services/coins.service";
import { PorposalExpectedResult } from "@/enums/PorposalExpectedResult";
import ProposalMember from "../../models/porposal/porposalMembers.model";
import ProposalDocument from "@/models/porposal/proposalDocument.Model";
import MemberTypeService from "@/services/memberType.service";
import ProjectTypeService from "@/services/projectType.service";
import DocumentComponent from "@/components/PublishAnnoucement/document.vue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Document from "../../models/document.model";
import ProposedConsortium from "@/models/porposal/proposedConsortium.Model";
import moment from "moment";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import PorposalBudgetItem from "@/models/porposal/porposalBudgetItem.model";
import { BudgetItemCalculation } from "@/enums/BudgetItemCalculation";
import BudgetExpenseService from "@/services/budgetExpense.service";
import AnnoucementAreasService from "@/services/AnnoumentArea.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import ResearchCenterService from "@/services/researchCenter.service";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import DocumentComponentViewer from "@/components/document-component-view/documentComponentViewer.vue";
import UserService from "@/services/user.service";
import PorposalService from "@/services/porposal.service";
import PorposalDetail from "@/components/porposal-detail-component/detail-optimized.vue";
//import PorposalDetail from "@/components/porposal-detail-component/detail.vue";
import { ProposalState } from "@/enums/ProposalState";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes.ts";
import ProporsalUsersEvaluators from "@/models/porposal/proporsalUsersEvaluators.Model";
import TipoEvaluacion from "../../models/evaluacion/tipoEvaluacion.model";
import AnnoucementEvaluationType from "../../models/annoucement/annoucementEvaluationType.Model";
import { ProjectState } from "@/enums/projectState";
import Annoucement from '../../models/annoucement/annoucement.Model';
import { PermissionValue } from '@/enums/PermissionValue';
import PermissionAccess from '@/models/security/permissionAccess.model';
@Component({
  components: {
    DatePickerComponent,
    documentcomponent: DocumentComponent,
    ResearchCenterBasicInformationComponent,
    UserBasicInformationComponent,
    DocumentComponentViewer,
    PorposalDetail,
    BaseSelectPerson
  }
})
export default class PorposalDetailFondocyt extends GenericEdit<Porposal> {
  currentTab = 1;
  isComponentModalActive: boolean = false;
  showModalEvaluadores: boolean = false;
  areas: any = [];
  motivoDevolucion: string = null;
  accionARealizar: string = null;
  fieldAreas: any = [];
  fieldAreasResearchLines: any = [];
  researchCenter: any = null;
  PorposalModality = PorposalModality;
  PorposalExpectedResult = PorposalExpectedResult;
  CoinService = new CoinService();
  memberTypeService: MemberTypeService = new MemberTypeService();
  projectTypeService: ProjectTypeService = new ProjectTypeService();
  annoucementAreasService: AnnoucementAreasService = new AnnoucementAreasService();
  researchCenterService: ResearchCenterService = new ResearchCenterService();
  userService: UserService = new UserService();
  proposalService: PorposalService = new PorposalService();
  researchCenters = [];
  counter: number;
  loading = false;
  dropFiles = [];
  annoucementId: number | null = null;
  years: Array<number> = [];
  budgetItemCurrent = new PorposalBudgetItem();
  showAddPartida = false;
  budgetExpenseService = new BudgetExpenseService();
  BudgetItemCalculation = BudgetItemCalculation;
  showWarning = false;
  fechaEvaluador: any = null;
  fechaEvaluadorCientificoTecnico: any = null;
  fechaEvaluadorFinanciero: any = null;
  paresEvaluadores = [];
  evaluadoresPertinencia = [];
  evaluadoresCientificoTecnico = [];
  evaluadoresFinanciero = [];
  showAnswersTab: boolean = true;
  inProgressState: ProjectState = ProjectState.InProgress;
  evaluador: any = null;
  evaluadorCientificoTecnico: any = null;
  evaluadorFinanciero: any = null;
  annoucement = new Annoucement();
  resetPertinenciaSelect: boolean = false;
  resetCientificoTecnicoSelect: boolean = false;
  resetFinancieroSelect: boolean = false;
  aprobado: ProposalState = ProposalState.AprobadoFC;
  devuelto: ProposalState = ProposalState.DevueltoFC;
  rechazado: ProposalState = ProposalState.RechazadoFC;
  cerrado: ProposalState = ProposalState.CerradoFC;
  annoucementService: AnnoucementService = new AnnoucementService();
  evaluationTypes: Array<AnnoucementEvaluationType> = [];
  movimientos: [] = [];
  permissionValue: PermissionValue = PermissionValue.INICIO;
  permissionAccess:PermissionAccess | any = {};
  constructor() {
    super();
    this.controller = "Porposal";
    this.model = new Porposal();
  }

  get isDisabled() {
    return this.model.estado == this.devuelto ||
      this.model.estado == this.aprobado ||
      this.model.estado == this.rechazado
      ? true
      : false;
  }
   

  @Watch("model.annoucementId")
  getAnnoucementDetail() 
  {
    this.loading = true;
    this.annoucementService
      .getDetailAnnocement(this.model.annoucementId)
      .then((response:any) => {
        this.annoucement = response;
        this.loading = false;
        console.log(this.annoucement)
      });
  }

  eliminarEvaluador(evaluationTypeId, userId, index) {
    let currentEvaluationType = this.evaluationTypes.find(
      x => x.id === evaluationTypeId
    );
    this.evaluationTypes = this.evaluationTypes.filter(
      x => x.id !== evaluationTypeId
    );

    let deletedProporsalUserEvaluator = currentEvaluationType.proporsalUsersEvaluators.find(
      x => x.userId === userId && !x.deleted
    );

    if (deletedProporsalUserEvaluator.id > 0) {
      deletedProporsalUserEvaluator.deleted = true;
    } else {
      currentEvaluationType.proporsalUsersEvaluators = currentEvaluationType.proporsalUsersEvaluators.filter(x => x.userId !== userId);
    }
    
    this.evaluationTypes.push(currentEvaluationType);
  }

  addEvaluator(evaluationTypeId) {
    let refEvaluationType = this.evaluationTypes.find(
      x => x.id === evaluationTypeId
    );

    if (!refEvaluationType.proporsalUsersEvaluators)
      refEvaluationType.proporsalUsersEvaluators = [];

    let proporsalUserEvaluator = new ProporsalUsersEvaluators();
    proporsalUserEvaluator.userId = refEvaluationType.evaluatorUI.id;
    proporsalUserEvaluator.user = refEvaluationType.evaluatorUI;
    proporsalUserEvaluator.fechaLimite = refEvaluationType.maximumEvaluationDateUI;
    proporsalUserEvaluator.porposalId = Number(this.$route.params.id);
    proporsalUserEvaluator.evaluationTypeId = refEvaluationType.evaluationTypeId;
  
    if (refEvaluationType.proporsalUsersEvaluators.some(x => x.userId === proporsalUserEvaluator.userId)) {
      let proposalEvaluator = refEvaluationType.proporsalUsersEvaluators.find(x => x.userId === proporsalUserEvaluator.userId);
      if (proposalEvaluator.deleted) {
        proposalEvaluator.fechaLimite = refEvaluationType.maximumEvaluationDateUI;
        proposalEvaluator.deleted = false;

      } else {
        this.operationNoAllowed('Ya se ha agregado este evaluador');
      }
    } else {
      refEvaluationType.proporsalUsersEvaluators.push(proporsalUserEvaluator);
      
    }
    
    // to reset and clean
    refEvaluationType.evaluatorUI = null;
    refEvaluationType.maximumEvaluationDateUI = null;
  }

  enviarEvaluadores() {
    let sePuedeEnviar = true;
    let restricciones = [];

    this.evaluationTypes.forEach(evaluationType => {
      if (
        !evaluationType.proporsalUsersEvaluators ||
        evaluationType.minimumNumberOfEvaluators >
          evaluationType.proporsalUsersEvaluators.filter(x => !x.deleted).length
      ) {
        sePuedeEnviar = false;
        let evaluadorLabel =
          evaluationType.minimumNumberOfEvaluators >= 2
            ? "evaluadores"
            : "evaluador";
        restricciones.push(
          `Debe tener al menos ${evaluationType.minimumNumberOfEvaluators} ${evaluadorLabel} del ${evaluationType.evaluationType.titulo}`
        );
      }
    });
    if (sePuedeEnviar) {
      this.showModalEvaluadores = false;
      this.loading = true;
      this.paresEvaluadores = [];
      this.evaluationTypes.forEach(evaluationType => {
        this.paresEvaluadores = this.paresEvaluadores.concat(
          evaluationType.proporsalUsersEvaluators
        );
      });
      let dto = {
        porposalId: Number(this.$route.params.id),
        paresEvaluadores: this.paresEvaluadores.map(x => {
          x.user = null;
          return x;
        })
      };
 
      this.proposalService
        .agregarEvaluadoresALaPropuesta(dto)
        .then(response => {
          if (response) {
            this.getData();
            this.operationPublish("Asignación realizada correctamente.");
            
            this.showAnswersTab = false;
            setTimeout(() => {
              this.showAnswersTab = true;
            }, 0.001);
          }
          this.loading = false;
          this.getEvaluators();
        });
    } else {
      restricciones.forEach(restriccion => {
        this.operationNoAllowed(restriccion, 2000);
      });
    }
  }

  mostrarModal(accion) {
    this.isComponentModalActive = true;
    this.accionARealizar = accion;
  }

  realizarAccionSobreLaPropuesta() {
    let model = {
      id: parseInt(this.$route.params.id),
      estado: ProposalState.EnviadoFC,
      motivo: this.motivoDevolucion
    };
    if (this.accionARealizar === "devolver") {
      if (this.motivoDevolucion) this.devolverPropuesta(model);
      else {
        this.$buefy.toast.open({
          message: "Debe escribir un motivo.",
          type: "is-warning",
          duration: 2000
        });
      }
    }
  }

  devolverPropuesta(model) {
    this.loading = true;
    this.isComponentModalActive = false;
    model.estado = ProposalState.DevueltoFC;
    this.proposalService.managePropuestaFC(model).then(response => {
      if (response) {
        this.movimientos = response;
        this.$buefy.toast.open({
          message: "Se ha devuelto exitosamente ",
          type: "is-success",
          duration: 2000
        });
        this.model.estado = ProposalState.DevueltoFC;
      }
      this.loading = false;
    });
  }

  async requestReport() {
    this.model.hasFondocytNotification = true;
    let id = Number(this.$route.params.id);
    await this.proposalService.requestLastReport(id);
    this.operationSuccess(
      "Se ha solicitado el reporte final de manera exitosa!"
    );
  }

  protected async getData() {
    try {
      this.loading = true;
      let response = await this.proposalService.getFondocytRequiredInformation(this.id); 
      //this.repository.byId(this.id, this.include);
      if (response.startDate) response.startDate = new Date(response.startDate);
      if (response.endDate) response.endDate = new Date(response.endDate);
      this.model = response;
      this.annoucementId = this.model.annoucementId as number;
      this.modelInit = this.map<Porposal>(this.model);
      this.getEvaluators();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.loading = false;
    }
  }

  getEvaluators() {
    this.annoucementService
      .getDetailAnnocement(this.model.annoucementId)
      .then(response => {
        if (response) {
          this.evaluationTypes = response.annoucementEvaluationsTypes;
          
          if (
            this.model.proporsalUsersEvaluators &&
            this.model.proporsalUsersEvaluators.length > 0
          ) {
            this.evaluationTypes.forEach(evaluationType => {
              evaluationType.proporsalUsersEvaluators = this.model.proporsalUsersEvaluators.filter(
                x => x.evaluationTypeId == evaluationType.evaluationTypeId
              );
            });
          }
        }
      });
  }

  get user() {
    return this.$store.state.user;
  }

  get displayMoreEvaluatorsRequiredAlert() {
    return this.$store.state.displayMoreEvaluatorsRequiredAlert
  }

  created() {

    this.permissionValue = PermissionValue.PROPUESTASFONDOCYT;
    this.permissionAccess = this.userService.getPermissionAccessLevel(this.permissionValue);
  }
}
